import { useEffect, useState } from 'react';
import { Modal } from '@/components/antd-wrapper/modal/global/modal';
import { getFileNameByUrl } from '@/lib/utils/url';
import SkillsFileRender from './skill-detail-model/skills-file-render';
import { SkillFileStateProvider } from '@/contexts/skill-file-state-context';
import { SkillFileEditProvider } from '@/contexts/skill-file-edit-context';

// 自定义事件名称
export const OPEN_SKILL_FILE_MODAL_EVENT = 'openSkillFileModal';

interface SkillFilePreviewData {
  skillId: string;
  filePath: string;
}

interface SkillFileModalProps {
  isOpen: boolean;
  data?: SkillFilePreviewData;
  onClose: () => void;
}

// 触发技能文件预览弹窗
export function triggerSkillFileModal(data: SkillFilePreviewData) {
  const event = new CustomEvent(OPEN_SKILL_FILE_MODAL_EVENT, {
    detail: { data },
  });
  window.dispatchEvent(event);
}

const SkillFileModal = (props: SkillFileModalProps) => {
  const { isOpen, onClose, data } = props;
  const fileName = getFileNameByUrl(data?.filePath || '');

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      title={<span className="text-[#000000BF]">{fileName}</span>}
      width={800}
      height={608}
      footer={null}
      classNames={{
        content: '!p-0',
      }}
    >
      {data && (
        <div className="h-[calc(608px-56px)] overflow-y-auto px-6 pt-4">
          <div className="bg-[#F4F4F5] rounded-t-[12px] p-4 min-h-full">
            <SkillFileStateProvider>
              <SkillFileEditProvider skillId={data.skillId || ''}>
                <SkillsFileRender
                  filePath={data.filePath}
                  skillsId={data.skillId}
                  highlightedFilePath={false}
                />
              </SkillFileEditProvider>
            </SkillFileStateProvider>
          </div>
        </div>
      )}
    </Modal>
  );
};

export const SkillFileModalWrapper = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalProps, setModalProps] = useState<SkillFileModalProps>();

  const handleOpenModal = (event: CustomEvent) => {
    const { data } = event.detail;
    setIsOpen(true);
    setModalProps({
      isOpen: true,
      data,
      onClose: () => setIsOpen(false),
    });
  };

  useEffect(() => {
    window.addEventListener(
      OPEN_SKILL_FILE_MODAL_EVENT,
      handleOpenModal as any,
    );
    return () => {
      window.removeEventListener(
        OPEN_SKILL_FILE_MODAL_EVENT,
        handleOpenModal as any,
      );
    };
  }, []);

  if (!isOpen || !modalProps) {
    return null;
  }

  return <SkillFileModal {...modalProps} />;
};

export default SkillFileModal;
